import React from 'react';
import styles from './DropdownMenu.module.less';

const DropdownMenu = ({ onSelectionChange, options, ...props }) => {
  return (
    <ul className={styles.container} {...props}>
      {options?.map(({ label, value }) => (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <li key={value} className={styles.menuItem} onClick={() => onSelectionChange(value)}>
          {label}
        </li>
      ))}
    </ul>
  );
};

export default DropdownMenu;
